
import React, { useState } from 'react';

export const FAQSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const faqs = [
    {
      question: '輸入外勞工資標準是多少？',
      answer: '根據勞工處《主要職位及每月中位工資一覽表》，僱主提供的薪金需不低於市場同類職位的中位工資。如某些職位無中位工資數據，申請時主任會提供合適薪資範圍供參考。'
    },
    {
      question: '餐飲集團如何申請？',
      answer: '可使用旗下子公司的名義申請，需提交全部分公司名單，供主任審核確認。'
    },
    {
      question: '輸入外勞有國籍限制嗎？',
      answer: '本計劃對外勞國籍無限制，但需注意當地出境手續。如有特殊需求，我們可提供協助。本公司在菲律賓設有招聘辦公室，隨時支援。'
    },
    {
      question: '僱主需提供住宿嗎？',
      answer: '僱主可自願提供居所，並從薪金中扣除最多10%作為住宿費。外勞亦可選擇住在內地居所，靈活安排。'
    },
    {
      question: '可否同時申請多個工作地點？',
      answer: '當然可以，僱主可填寫多個不同工作地點，滿足業務需求。'
    },
    {
      question: '若本地招聘無合適人選，會否影響配額申請？',
      answer: '招聘期結束後，需向補充勞工科提交本地招聘結果及合理解釋，符合要求不會影響後續配額申請。'
    },
    {
      question: '若自行找到合適人選，可否找貴公司處理流程？',
      answer: '可以！配額批出後，我們合作的內地指定勞務公司會聯繫外勞辦理簽證。根據《對外勞務合作管理條例》，勞務公司會收取相關費用。'
    },
    {
      question: '勞工辭職或解僱如何處理？',
      answer: '按香港勞工法例辦理，通知期依據合約中約定時間執行。'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            常見問題解答
          </h2>
          <p className="text-xl text-gray-600">
            為您解答外勞招聘過程中的常見疑問
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
              <button
                className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-gray-50 transition-colors rounded-xl"
                onClick={() => setActiveTab(activeTab === index ? -1 : index)}
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <div className="flex-shrink-0">
                  <i className={`ri-arrow-${activeTab === index ? 'up' : 'down'}-s-line text-green-600 text-xl`}></i>
                </div>
              </button>
              {activeTab === index && (
                <div className="px-6 pb-5 border-t border-gray-100">
                  <p className="text-gray-600 pt-4 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white p-8 rounded-xl">
            <h3 className="text-2xl font-bold mb-4">還有其他問題？</h3>
            <p className="text-lg mb-6">我們的專業團隊隨時為您提供詳細諮詢</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel://+85293663961"
                className="bg-white text-green-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap inline-flex items-center justify-center cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                致電查詢
              </a>
              <a 
                href="https://wa.me/85293663961"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-green-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap inline-flex items-center justify-center"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp查詢
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
